import { LandAreaContainer } from '../../containers/filters/LandAreaContainer';
import { EFilterType, IDefaultFilter } from '../../types/filters';

export const landArea: IDefaultFilter = {
  component: LandAreaContainer,
  type: EFilterType.Default,
};
